// Préférences locales (UI-15) : localStorage peut être indisponible (navigation
// privée, stockage bloqué). Toute lecture ou écriture est protégée ; aucune
// préférence ne contient de secret ni de hash d'API.

export function readPref(key, fallback = null) {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? fallback : JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function writePref(key, value) {
  try {
    if (value === null || value === undefined) window.localStorage.removeItem(key);
    else window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* préférence non mémorisée : elle vaut pour la session en cours */
  }
}
